import { useDispatch, useSelector } from "react-redux";
import { hideLoading, logOut, showLoading, userData } from "../features/general/generalSlice";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config/constants";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _userData = useSelector(userData);

  const handleLogout = async ()=> {
    try {
      setTimeout(() => {
        dispatch(showLoading());
      }, 100);
      const response = await axios.post(`${API_URL}/auth`, {
        callback: 'logout'
      }, {
        withCredentials: true  // Allows cross-origin cookies if server allows
      });
      if(response?.status === 200){
        setTimeout(() => {
          dispatch(logOut());
          navigate('/login');
        }, 1000);
      }else{
        toast.error(`${response?.status}: ${response?.statusText}`);
      }
    } catch (error) {
      toast.error(`Error : ${error.message}`);
    } finally{
      setTimeout(() => {
        dispatch(hideLoading());
      }, 1000);
    }
  }

  return (
    <>
      <ToastContainer
        position='top-center'
        autoClose={5000}
      />
      <div>Hi, {_userData.name} ({_userData.email})</div>
      <button onClick={handleLogout}>Logout</button>
    </>
  )
}

export default Dashboard;